import IMG01 from '../../assets/images/notes/1.jpeg'
import IMG02 from '../../assets/images/notes/2.png'
import IMG03 from '../../assets/images/notes/3.png'
import IMG04 from '../../assets/images/notes/4.jpeg'
import IMG05 from '../../assets/images/notes/5.png'
import IMG06 from '../../assets/images/notes/6.jpg'
import IMG07 from '../../assets/images/notes/7.jpg'
import IMG08 from '../../assets/images/notes/8.jpeg'
import IMG09 from '../../assets/images/notes/9.png'

export const HOME_NOTES = [
  // {
  //   image: '/images/home/notes/1.png',
  //   title: 'notes.notes.title1',
  //   description: 'notes.notes.description1',
  //   author: 'Author Here',
  //   date: '2023-10-01',
  //   link: '#',
  // },
  {
    image: IMG01,
    title: 'notes.notes.title1',
    description: 'notes.notes.description1',
    author: 'Fábio Bispo - InfoAmazonia',
    date: '05-11-2025',
    link_es:
      'https://infoamazonia.org/es/2025/11/05/patrocinadora-de-la-cop30-vale-compra-creditos-de-carbono-de-un-area-en-la-amazonia-implicada-en-manejo-maderero-ilegal/',
    link_pt:
      'https://infoamazonia.org/2025/11/05/patrocinadora-da-cop30-vale-compra-creditos-de-carbono-de-area-na-amazonia-acusada-de-irregularidades-no-manejo-madeireiro/',
    link_en:
      'https://infoamazonia.org/en/2025/11/05/as-a-sponsor-of-cop30-vale-buys-carbon-credits-from-an-area-in-the-amazon-accused-of-irregularities-in-timber-management/',
  },
  {
    image: IMG02,
    title: 'notes.notes.title2',
    description: 'notes.notes.description2',
    author: 'Fábio Bispo - InfoAmazonia',
    date: '26-06-2025',
    link_es:
      'https://www.elclip.org/los-creditos-de-carbono-de-la-amazonia-brasilera-estan-untados-de-mineria/',
    link_pt:
      'https://infoamazonia.org/2025/06/26/mais-da-metade-dos-creditos-de-carbono-da-amazonia-esta-contaminada-pela-mineracao/',
    link_en:
      'https://www.elclip.org/los-creditos-de-carbono-de-la-amazonia-brasilera-estan-untados-de-mineria/',
  },
  {
    image: IMG03,
    title: 'notes.notes.title3',
    description: 'notes.notes.description3',
    author: 'Andrés Bermúdez Liévano (CLIP)',
    date: '14-05-2025',
    link_es:
      'https://www.elclip.org/chevron-compro-bonos-de-carbono-a-proyecto-hecho-nuevamente-de-espaldas-a-indigenas/',
    link_pt:
      'https://www.elclip.org/chevron-compro-bonos-de-carbono-a-proyecto-hecho-nuevamente-de-espaldas-a-indigenas/',
    link_en:
      'https://www.elclip.org/chevron-compro-bonos-de-carbono-a-proyecto-hecho-nuevamente-de-espaldas-a-indigenas/?lang=en',
  },
  /*{
    image: IMG04,
    title: 'notes.notes.title5',
    description: 'notes.notes.description5',
    author:
      'Rutas del Conflicto, Centro Latinoamericano de Investigación Periodística (CLIP)',
    date: '04-02-2025',
    link_es:
      'https://www.elclip.org/el-proyecto-de-carbono-en-el-pacifico-colombiano-que-se-traslapa-con-territorios-afro/',
    link_pt:
      'https://www.elclip.org/el-proyecto-de-carbono-en-el-pacifico-colombiano-que-se-traslapa-con-territorios-afro/',
    link_en:
      'https://www.elclip.org/el-proyecto-de-carbono-en-el-pacifico-colombiano-que-se-traslapa-con-territorios-afro/?lang=en',
  },
  {
    image: IMG05,
    title: 'notes.notes.title5',
    description: 'notes.notes.description5',
    author: 'Andrés Bermúdez Liévano (CLIP)',
    date: '18-09-2024',
    link_es:
      'https://www.elclip.org/proyecto-carbono-suspendido-sigue-transando-bonos-e-incumple-fallo-judicial/',
    link_pt:
      'https://www.elclip.org/proyecto-carbono-suspendido-sigue-transando-bonos-e-incumple-fallo-judicial/',
    link_en:
      'https://www.elclip.org/proyecto-carbono-suspendido-sigue-transando-bonos-e-incumple-fallo-judicial/?lang=en',
  },
  {
    image: IMG06,
    title: 'notes.notes.title6',
    description: 'notes.notes.description6',
    author: 'Claudia Antunes y Rafael Moro Martins (Sumaúma)',
    date: '02-08-2024',
    link_es:
      'https://www.elclip.org/la-agencia-indigenista-de-brasil-exige-que-se-investiguen-los-contratos-de-michael-greene-con-los-pueblos-originarios/',
    link_pt:
      'https://sumauma.com/funai-pede-a-orgaos-federais-que-investiguem-contratos-de-michael-greene-com-indigenas/',
    link_en:
      'https://www.elclip.org/la-agencia-indigenista-de-brasil-exige-que-se-investiguen-los-contratos-de-michael-greene-con-los-pueblos-originarios/?lang=en',
  },
  {
    image: IMG07,
    title: 'notes.notes.title7',
    description: 'notes.notes.description7',
    author: 'Claudia Antunes (Sumaúma)',
    date: '26-06-2024',
    link_es:
      'https://www.elclip.org/cowboys-carbono-senor-greene-amazonia-brasilena/',
    link_pt:
      'https://sumauma.com/caubois-do-carbono-o-jogo-arriscado-de-mister-greene-no-vale-tudo-da-amazonia-brasileira/',
    link_en:
      'https://www.elclip.org/cowboys-carbono-senor-greene-amazonia-brasilena/?lang=en',
  },
  {
    image: IMG08,
    title: 'notes.notes.title8',
    description: 'notes.notes.description8',
    author: 'Fernanda Wenzel (Mongabay Brasil)',
    date: '28-06-2024',
    link_es:
      'https://www.elclip.org/policia-detiene-involucrados-proyectos-creditos-carbono-problematicos-amazonia-brasilena/',
    link_pt:
      'https://brasil.mongabay.com/2024/11/policia-federal-coloca-fim-ao-cerco-a-acampados-que-lutam-pela-terra-no-para/',
    link_en:
      'https://www.elclip.org/policia-detiene-involucrados-proyectos-creditos-carbono-problematicos-amazonia-brasilena/',
  },
  {
    image: IMG09,
    title: 'notes.notes.title9',
    description: 'notes.notes.description9',
    author: 'Fernanda Wenzel (Mongabay Brasil)',
    date: '21-05-2024',
    link_es:
      'https://www.elclip.org/creditos-carbono-presunta-estafa-blanqueo-madera-amazonia/',
    link_pt:
      'https://brasil.mongabay.com/2024/05/grandes-marcas-compram-creditos-de-carbono-de-esquema-suspeito-de-esquentamento-de-madeira-na-amazonia/',
    link_en:
      'https://www.elclip.org/creditos-carbono-presunta-estafa-blanqueo-madera-amazonia/?lang=en',
  },*/
]
